<script setup lang="ts">
const store = usePortfolioStore()
</script>

<template>
  <section id="projects" class=" py-6">
    <h2 class="text-2xl font-extrabold md:text-3xl text-center">پروژه‌ها</h2>
    <p class="mt-2 text-[13px] text-muted text-center">تازه‌ترین کارهایی که تحویل داده‌ام</p>
    <div class="mt-6 grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3">
      <NuxtLink v-for="p in store.projects" :key="p.id ?? p.slug" :to="'/projects/' + (p.slug || p.id)" data-reveal
                class="overflow-hidden border border-line bg-surface transition duration-500
                       hover:-translate-y-1.5 hover:shadow-[var(--t-glow)]">
        <div class="aspect-[16/10] bg-surface-2">
          <img v-if="p.media" :src="p.media?.url" :alt="p.title" loading="lazy" decoding="async"
               class="h-full w-full object-cover" />
        </div>
        <div class="p-4">
          <h3 class="font-bold">{{ p.title }}</h3>
          <p class="mt-1.5 text-xs leading-6 text-muted">{{ p.summary }}</p>
          <ul class="mt-3 flex flex-wrap gap-1.5">
            <li v-for="t in p.tags" :key="t"
                class="rounded bg-[var(--t-accent-soft)] px-2 py-1 text-[11px] font-bold text-accent-2">{{ t }}</li>
          </ul>
        </div>
      </NuxtLink>
    </div>
  </section>
</template>
